var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 3.33301H14.9999C15.4419 3.33301 15.8659 3.5086 16.1784 3.82116C16.491 4.13372 16.6666 4.55765 16.6666 4.99967V16.6663C16.6666 17.1084 16.491 17.5323 16.1784 17.8449C15.8659 18.1574 15.4419 18.333 14.9999 18.333H4.99992C4.55789 18.333 4.13397 18.1574 3.82141 17.8449C3.50885 17.5323 3.33325 17.1084 3.33325 16.6663V4.99967C3.33325 4.55765 3.50885 4.13372 3.82141 3.82116C4.13397 3.5086 4.55789 3.33301 4.99992 3.33301H6.66658",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 1.66699H7.50008C7.03984 1.66699 6.66675 2.04009 6.66675 2.50033V4.16699C6.66675 4.62723 7.03984 5.00033 7.50008 5.00033H12.5001C12.9603 5.00033 13.3334 4.62723 13.3334 4.16699V2.50033C13.3334 2.04009 12.9603 1.66699 12.5001 1.66699Z",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/productIcon.dab8edb8d3ca75a4bedccaab5956f3bc.svg";
export { ForwardRef as ReactComponent };